import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import getOrderDetailDms from '../../modules/order/application/getOrderDetailDms';
import createApiOrderRepository from '../../modules/order/infrastructure/apiOrderRepository';
import isMainOrderClosed from '../../modules/order/application/isMainOrderClosed';
import STATE_STATUSES from '../state-statuses';

const repository = createApiOrderRepository();

export default {
  namespaced: true,

  state: {
    taxPercentage: 0,
    isMainOrderClosed: false,
    isMainOrderClosedStatus: STATE_STATUSES.UNINITIALIZED,
  },

  getters: {
    getTaxPercentage(state) {
      return state.taxPercentage;
    },

    getIsMainOrderClosed(state) {
      return state.isMainOrderClosed;
    },

    getIsMainOrderClosedStatus(state) {
      return state.isMainOrderClosedStatus;
    },
  },

  mutations: {
    SET_TAX_PERCENTAGE(state, payload) {
      Vue.set(state, 'taxPercentage', payload);
    },

    SET_IS_MAIN_ORDER_CLOSED(state, payload) {
      Vue.set(state, 'isMainOrderClosed', payload);
    },

    SET_IS_MAIN_ORDER_CLOSED_STATUS(state, payload) {
      Vue.set(state, 'isMainOrderClosedStatus', payload);
    },
  },

  actions: {
    // TODO: Find a way to omit this endpoint call,
    // since it's called only to retrieve the tax percentage.
    async getOrderDetailDms({ commit }) {
      const ordersSession = Vue.prototype.$session.get('orders');
      const orders = Array.isArray(ordersSession) ? ordersSession : [];

      if (!orders.length) return;

      const lastOrder = orders[orders.length - 1];
      const orderIdDMS = lastOrder && lastOrder.orderIdDMS ? String(lastOrder.orderIdDMS).trim() : '';

      const dealerIdRaw = Vue.prototype.$session.get('dealerId');
      const dealerId = Number(dealerIdRaw);

      if (!orderIdDMS) return;
      if (!dealerId || Number.isNaN(dealerId)) return;

      try {
        const ONE_HUNDRED_PERCENTAGE = 100;

        const params = {
          orderId: orderIdDMS,
          transactionId: uuidv4(),
          dealerId,
        };

        const orderDMS = await getOrderDetailDms(repository, params);

        const taxePercentage = orderDMS.taxTypePercentage / ONE_HUNDRED_PERCENTAGE;
        commit('SET_TAX_PERCENTAGE', taxePercentage);
      } catch (err) {
        commit('SET_TAX_PERCENTAGE', 0);
        throw err;
      }
    },

    async triggerIsMainOrderClosed({ commit }, { superOrderIdDms, email, dealerId }) {
      commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.LOADING);

      try {
        const isClosed = await isMainOrderClosed(repository, {
          superOrderIdDms,
          email,
          dealerId,
        });

        commit('SET_IS_MAIN_ORDER_CLOSED', isClosed);
        commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.SUCCESS);
      } catch {
        commit('SET_IS_MAIN_ORDER_CLOSED', false);
        commit('SET_IS_MAIN_ORDER_CLOSED_STATUS', STATE_STATUSES.ERROR);
      }
    },
  },
};
